import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_d0fccf8a";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_d0fccf8a" };
/** script content **/
require("./switch.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexd0fccf8a%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fswitch%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_d0fccf8a"],
    ctorType: "component",
    outputPath: "components/indexd0fccf8a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
